/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Scrape_NowInputs */

const en_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrape Now`)
};

const de_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt scrapen`)
};

const fr_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérer maintenant`)
};

const es_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recopilar ahora`)
};

const it_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca ora`)
};

const nl_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu zoeken`)
};

const pl_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj teraz`)
};

const fi_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae nyt`)
};

const da_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrab nu`)
};

const sv_jobs_scrape_now = /** @type {(inputs: Jobs_Scrape_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrapa nu`)
};

/**
* | output |
* | --- |
* | "Scrape Now" |
*
* @param {Jobs_Scrape_NowInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_scrape_now = /** @type {((inputs?: Jobs_Scrape_NowInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Scrape_NowInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_scrape_now(inputs)
	if (locale === "fr") return fr_jobs_scrape_now(inputs)
	if (locale === "es") return es_jobs_scrape_now(inputs)
	if (locale === "it") return it_jobs_scrape_now(inputs)
	if (locale === "nl") return nl_jobs_scrape_now(inputs)
	if (locale === "pl") return pl_jobs_scrape_now(inputs)
	if (locale === "fi") return fi_jobs_scrape_now(inputs)
	if (locale === "da") return da_jobs_scrape_now(inputs)
	if (locale === "sv") return sv_jobs_scrape_now(inputs)
	return en_jobs_scrape_now(inputs)
});